import Collapse from 'bootstrap/js/dist/collapse.js';
import Dropdown from 'bootstrap/js/dist/dropdown.js';
import Popover from 'bootstrap/js/dist/popover.js';
import Tab from 'bootstrap/js/dist/tab.js';
import Tooltip from 'bootstrap/js/dist/tooltip.js';

// Dummy function to prevent tree shaking
function useBootstrapModules() {
    Collapse;
    Dropdown;
    Popover;
    Tab;
    Tooltip;
}

useBootstrapModules();